/* global opr */
import _ from 'lodash';

const browserName = function () { // eslint-disable-line func-names
  const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  if (isOpera) {
    return 'opera';
  }

  // Firefox 1.0+
  const isFirefox = typeof InstallTrigger !== 'undefined';
  if (isFirefox) {
    return 'firefox';
  }

  // Safari <= 9 "[object HTMLElementConstructor]"
  const isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
  if (isSafari) {
    return 'safari';
  }

  // Internet Explorer 6-11
  const isIE = /*@cc_on!@*/false || !!document.documentMode; // eslint-disable-line spaced-comment
  if (isIE) {
    return 'ie';
  }

  // Edge 20+
  const isEdge = !isIE && !!window.StyleMedia;
  if (isEdge) {
    return 'edge';
  }

  // Chrome 1+
  const isChrome = !!window.chrome && !!window.chrome.webstore;
  if (isChrome) {
    return 'chrome';
  }

  return '';
};

const iterateThroughObject = function (obj, callback, aggrKey, origObj) { // eslint-disable-line prefer-arrow-callback, func-names, max-len
  if (typeof aggrKey === 'undefined') {
    aggrKey = ''; // eslint-disable-line no-param-reassign
  }
  if (typeof origObj === 'undefined') {
    origObj = obj; // eslint-disable-line no-param-reassign
  }

  _.forEach(obj, function (value, key) { // eslint-disable-line prefer-arrow-callback, func-names
    const fullKey = aggrKey + key;
    const val = _.get(origObj, fullKey);
    if (typeof val === 'undefined') {
      const keyParts = aggrKey.split('.');
      // shortens key by one
      // "a.b.c.".split('.') == ['a', 'b', 'c', '']
      keyParts.pop();
      keyParts.pop();
      aggrKey = keyParts.join('.'); // eslint-disable-line no-param-reassign
      // null is object....
      if ((value === null || typeof value !== 'object') && aggrKey !== '') {
        aggrKey += '.'; // eslint-disable-line prefer-template, no-param-reassign
      }
    }
    if (typeof value === 'object' && value !== null) {
      aggrKey += key + '.'; // eslint-disable-line prefer-template, no-param-reassign
      iterateThroughObject(value, callback, aggrKey, origObj);
    } else {
      callback(value, key, aggrKey + key);
    }
  });
};

module.exports = {
  browserName,
  iterateThroughObject,
};
